import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { eventService } from '../services/firebaseService';
import { EventItem } from '../types';

const EventsPage: React.FC = () => {
  const [events, setEvents] = useState<EventItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    eventService.getUpcomingEvents().then(list => {
      console.log('✅ Events loaded:', list.length, list);
      setEvents(list);
      setLoading(false);
    }).catch((error) => {
      console.error('❌ Error loading events:', error);
      console.error('Error details:', error.code, error.message);
      setLoading(false);
    });
  }, []);
  return (
    <Layout>
      <div className="container">
        <h1>Events</h1>
        {loading ? (
          <div className="loading"><div className="spinner" /></div>
        ) : (
          <div className="grid">
            {events.map((e) => (
              <div className="card" key={e.id}>
                <h3>{e.title}</h3>
                {e.date && <p style={{ color: 'var(--text-dark)' }}>{String((e as any).date?.toDate ? (e as any).date.toDate().toLocaleString() : e.date)}</p>}
                {e.location && <p>{e.location}</p>}
                {e.description && <p>{e.description}</p>}
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default EventsPage;
